// src/services/auth.ts
import api, { webApi, getCsrfToken } from "../api";

export async function login(email: string, password: string) {
  await getCsrfToken();
  return webApi.post("/login", { email, password });
}

export async function register(
  firstname: string,
  lastname: string,
  email: string,
  phone: string,
  dob: string,
  village: string,
  password: string,
  password_confirmation: string
) {
  await getCsrfToken();
  return webApi.post("/register", {
    firstname,
    lastname,
    email,
    phone,
    dob,
    village,
    password,
    password_confirmation,
  });
}

export async function logout() {
  await getCsrfToken();
  return webApi.post("/logout");
}

export async function getUser() {
  return api.get("/user");
}
